module.exports = __webpack_public_path__ + "media/images/setup-bg-729d6fb7456e4e8b6c4579fb887c6702.svg";